import { NotificationManager } from 'react-notifications'
import loginApi from 'src/api/loginApi'
import Cookies from 'universal-cookie'

export const clearSession = async (toLogout = true) => {
  try {
    let logoutResult = await loginApi.logout()
    if (logoutResult?.status === 200) {
      clearCookies(toLogout)
    }
  } catch (error) {
    let result = error?.response?.data
    NotificationManager.error(result?.message || "Can't Logout!!")
    clearCookies(toLogout)
  }
}

export const clearCookies = (toLogout = true) => {
  const cookies = new Cookies()
  cookies.remove('role', { path: '/' })
  cookies.remove('userGroup', { path: '/' })
  cookies.remove('permission', { path: '/' })
  cookies.remove('currentMenu')
  cookies.remove('logged in')
  sessionStorage.clear()

  if (window?.location?.href?.indexOf('/Maintenance') < 0 && toLogout) {
    window.location.replace('#/back-office/login')
  }
}
